import React, { useState, useEffect } from 'react';
import './SplashScreen.css';

const SplashScreen = ({ onFinish }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => {
      setFadeOut(true);
      
      const fadeTimer = setTimeout(() => {
        setIsVisible(false);
        onFinish();
      }, 800);   // fade out चा वेळ
      
      return () => clearTimeout(fadeTimer);
    }, 3200);    // एकूण splash दिसण्याचा वेळ (3.2 सेकंद)

    return () => clearTimeout(showTimer);
  }, [onFinish]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        {/* Logo / Emblem */}
        <img
          src="/images/sj1.jpg"
          alt="राष्ट्रीय चिन्ह"
          className="splash-logo"
        />

        <h1>स्वागत आहे!</h1>
        <h2>गट ग्रामपंचायत गावसुत</h2>
        <p>पंचायत समिती उमरेड, जिल्हा नागपूर</p>
        
        {/* Loading Indicator */}
        <div className="loading-container">
          <div className="loading-bar">
            <div className="progress"></div>
          </div>
          <p className="loading-text">Loading Official Website...</p>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;